<template>
  <b-form-input
    class="ipv4-input"
    v-bind:value="value"
    :state="isFieldInvalid"
    :formatter="formatter"
    @focus="inUse = true"
    @blur="validateIpv4"
  />
</template>
<script>

export default {
  name: 'Ipv4Input',
  props: {
    value: {
      type: String,
      default: '',
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideValidation: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    inUse: false,
    requestPrefixRegex: /^(.*)(\/\/)(.*)/,
  }),
  computed: {
    ipv4FieldRegex() {
      const fieldNumbers = '(25[0-5]|2[0-4]\\d|[01]?\\d?\\d?)';
      const fieldDot = '([.]?)';
      const remainingIgnored = '(.*)';
      const regex = [
        fieldNumbers,
        fieldDot,
        fieldNumbers,
        fieldDot,
        fieldNumbers,
        fieldDot,
        fieldNumbers,
        remainingIgnored,
      ];

      return new RegExp(`^${regex.join('')}`);
    },
    ipv4Regex() {
      const fieldNumbers = '(25[0-5]|2[0-4]\\d|[01]?\\d?\\d)';
      const fieldDot = '([.])';
      const regex = [
        fieldNumbers,
        fieldDot,
        fieldNumbers,
        fieldDot,
        fieldNumbers,
        fieldDot,
        fieldNumbers,
      ];

      return new RegExp(`^${regex.join('')}$`);
    },
    isFieldInvalid() {
      if (this.inUse || this.hideValidation) {
        return null;
      }

      return this.isValid ? null : false;
    },
  },
  methods: {
    validateIpv4() {
      this.inUse = false;
      if (!this.required && this.value === '') {
        this.$emit('update:isValid', true);
        return;
      }

      const isValid = this.ipv4Regex.test(this.value);
      this.$emit('update:isValid', isValid);
    },
    formatter(value) {
      const valuePastedWithoutPrefix = this.removePrefixFromValue(value);
      const ipv4 = valuePastedWithoutPrefix.replace(this.ipv4FieldRegex, this.replacer);

      this.$emit('input', ipv4);
      return ipv4;
    },
    removePrefixFromValue(value) {
      return value.replace(this.requestPrefixRegex, '$3');
    },
    replacer(_, p1, p2, p3, p4, p5, p6, p7) {
      const ipv4ListSegment = [p1, p2, p3, p4, p5, p6, p7];

      const newList = ipv4ListSegment.map((current, index) => {
        const isTheDotSegment = index % 2 === 1;
        if (isTheDotSegment) {
          const actualDotIsEmpty = !current;
          const nextIpSegmentHasValue = ipv4ListSegment[index + 1];
          return actualDotIsEmpty && nextIpSegmentHasValue ? '.' : current;
        }

        const nextDotHasValue = ipv4ListSegment[index + 1];
        const actualIpSegmentIsEmpty = !current;
        return nextDotHasValue && actualIpSegmentIsEmpty ? '0' : current;
      });

      return `${newList.join('')}`;
    },
  },
};
</script>
